import {AInesAssistantType} from "@/graphql/generated/graphql";

export class AssistantRunConfig {
    public constructor(
        public readonly assistantType: AInesAssistantType,
        public readonly assistantId: string,
        public readonly threadId: string
    ) {}
}
